module.exports = __webpack_public_path__ + "static/media/webform-active.e4c8504d.svg";